module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rf-field rf-multiple",
    class: _vm.computedClass,
    attrs: {
      "data-name": _vm.name
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "rf-label"
  }, [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), (!_vm.options.length || _vm.allOptionsDisabled) ? _vm._t("fallback") : _vm._e(), _vm._v(" "), (!_vm.options.length || _vm.allOptionsDisabled) ? _c('input', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validation),
      expression: "validation"
    }],
    ref: "input",
    attrs: {
      "type": "text",
      "value": ""
    }
  }, 'input', {
    name: _vm.name
  }, false)) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "optionsContainer",
    staticClass: "rf-multiple-options",
    class: {
      'show-focus-style': _vm.showFocusStyle
    }
  }, [_vm._l((_vm.options), function(option, i) {
    return _c('label', {
      ref: "focus",
      refInFor: true,
      class: _vm.getLabelClass(option),
      attrs: {
        "tabindex": option.disabled || _vm.disabled ? -1 : 0
      },
      on: {
        "keyup": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
          _vm.onSpace(i)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
          _vm.showFocusStyle = true
        }],
        "click": function($event) {
          _vm.onClick($event)
        },
        "mousedown": function($event) {
          _vm.showFocusStyle = false
        }
      }
    }, [(_vm.type === 'radio') ? _c('input', _vm._b({
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value),
        expression: "value"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (_vm.validation),
        expression: "validation"
      }],
      ref: "input",
      refInFor: true,
      attrs: {
        "type": "radio",
        "tabindex": "-1",
        "disabled": option.disabled || _vm.disabled
      },
      domProps: {
        "value": _vm.getOptionValue(option),
        "checked": _vm._q(_vm.value, _vm.getOptionValue(option))
      },
      on: {
        "__c": function($event) {
          _vm.value = _vm.getOptionValue(option)
        }
      }
    }, 'input', {
      name: _vm.name
    }, false)) : _vm._e(), _vm._v(" "), (_vm.type === 'checkbox') ? _c('input', _vm._b({
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value),
        expression: "value"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (_vm.validation),
        expression: "validation"
      }],
      ref: "input",
      refInFor: true,
      attrs: {
        "type": "checkbox",
        "tabindex": "-1",
        "disabled": option.disabled || _vm.disabled
      },
      domProps: {
        "value": _vm.getOptionValue(option),
        "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, _vm.getOptionValue(option)) > -1 : (_vm.value)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.getOptionValue(option),
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.value = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.value = $$c
          }
        }
      }
    }, 'input', {
      name: _vm.name
    }, false)) : _vm._e(), _vm._v(" "), (_vm.type === 'checkbox') ? _c('div', {
      staticClass: "rf-checkbox-box"
    }, [_c('icon', {
      staticClass: "rf-icon",
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'radio') ? _c('div', {
      staticClass: "rf-radio-circle"
    }) : _vm._e(), _vm._v(" "), _vm._t("option", [_c('span', {
      staticClass: "option-label"
    }, [_vm._v(_vm._s(option.label || option))]), _vm._v(" "), (option.description) ? _c('span', {
      staticClass: "option-description"
    }, [_vm._v(_vm._s(option.description))]) : _vm._e()], {
      label: option.label || option,
      description: option.description
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade-fast"
      }
    }, [(_vm.showInvalid && i === 0) ? _c('icon', {
      staticClass: "rf-multiple-icon rf-icon-invalid",
      attrs: {
        "name": "exclamation-triangle"
      }
    }) : _vm._e()], 1)], 2)
  }), _vm._v(" "), (_vm.showInvalid) ? _c('rf-message', [_vm._v(_vm._s(_vm.errors.first(_vm.name)))]) : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a89507f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfMultiple.vue
// module id = 262
// module chunks = 0